var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0001 10C18.0001 14.4183 14.4184 18 10.0001 18C5.58184 18 2.00012 14.4183 2.00012 10C2.00012 5.58172 5.58184 2 10.0001 2C14.4184 2 18.0001 5.58172 18.0001 10ZM11.0001 6C11.0001 6.55228 10.5524 7 10.0001 7C9.44784 7 9.00012 6.55228 9.00012 6C9.00012 5.44772 9.44784 5 10.0001 5C10.5524 5 11.0001 5.44772 11.0001 6ZM9.00012 9C8.44784 9 8.00012 9.44772 8.00012 10C8.00012 10.5523 8.44784 11 9.00012 11V14C9.00012 14.5523 9.44784 15 10.0001 15H11.0001C11.5524 15 12.0001 14.5523 12.0001 14C12.0001 13.4477 11.5524 13 11.0001 13V10C11.0001 9.44772 10.5524 9 10.0001 9H9.00012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.a57807ed7e91be99e2df0d3e5b72df22.svg";
export { ForwardRef as ReactComponent };